import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

export const getOrderUrl = (orderId: number): string =>
  resolveUrl(AppRoute.OrdersShow, { id: orderId }) ?? ''

export const getOrderInvoiceUrl = (orderId: number): string =>
  resolveUrl(AppRoute.OrdersInvoice, { id: orderId }) ?? ''

export const getCustomerUrl = (customerId: number): string =>
  resolveUrl(AppRoute.CustomersShow, { id: customerId }) ?? ''

export const getKidUrl = (kidId: number): string =>
  resolveUrl(AppRoute.KidsShow, { id: kidId }) ?? ''

export const getDisciplineUrl = (disciplineId: number): string =>
  resolveUrl(AppRoute.DisciplinesGeneralInfo, { id: disciplineId }) ?? ''

/** An all-digits search narrows the subscriptions list to that id. */
export const getSubscriptionPath = (subscriptionId: number): string =>
  `${AppRoute.Subscriptions}?${new URLSearchParams({ q: String(subscriptionId) })}`

export const getTutorAttendanceRatesPath = (tutorId: number): string =>
  `${AppRoute.TutorAttendanceRates}?${new URLSearchParams({ tutor: String(tutorId) })}`
